/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlaceDto } from '../../models/place-dto';

export interface PlaceControllerFindAll$Params {
}

export function placeControllerFindAll(http: HttpClient, rootUrl: string, params?: PlaceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlaceDto>>> {
  const rb = new RequestBuilder(rootUrl, placeControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlaceDto>>;
    })
  );
}

placeControllerFindAll.PATH = '/api/places';
